<template>
  <div v-if="isArray" :style="style_" style="flex-direction: row;">
    <CampoRecursivo
      v-for="(subCampo, i) of campo.valor"
      :key="`${_key}_${i}`"
      :_key="`${_key}_${i}`"
      :data="data"
      :campo="subCampo"
    />
  </div>

  <span v-else class="TextRegularUnAlign FontsWhite" :style="style_">
   {{ formaters(data[campo.valor]) }}
  </span>
</template>

<script>
import { formaters, makeCSS } from "../utils";

// const formaters = {
//   price: v => NumberF(v, 1),
//   number: v => NumberF(v, 0, ".00"),
//   undefined: s => s
// }[campo.format];
export default {
  name: "CampoRecursivo",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    campo: {
      type: [Object, Array],
      default: () => ({})
    },
    _key: {
      type: String,
      default: ""
    }
  },
  computed: {
    isArray() {
      if (Array.isArray(this.campo.valor)) {
        debugger;
      }
      return Array.isArray(this.campo.valor);
    },
    style_() {
      return this.makeCSS(this.campo?.style);
    },
    formaters() {
      return formaters(this.campo?.format);
    }
  },
  methods: {
    makeCSS(v) {
      return makeCSS(v);
    }
  }
};
</script>

<style lang="scss" scoped>
.TextRegularUnAlign {
  font-weight: bold;
  font-size: 25px;
  color: #000;
  margin-right: 5px;
}
.FontsWhite {
  color: #fff;
}
</style>
